import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customDate'
})
export class CustomDatePipe implements PipeTransform {
  transform(created_at: string): string {
    const currentDate = new Date();
    const yesterday = new Date(currentDate);
    yesterday.setDate(currentDate.getDate() - 1);

    const createdDate = new Date(created_at);
    if (createdDate.toDateString() === currentDate.toDateString()) {
      return 'Today';
    } else if (createdDate.toDateString() === yesterday.toDateString()) {
      return 'Yesterday';
    } else {
      return createdDate.toLocaleString('en-US', { month: 'long', day: 'numeric' });
    }
  }
}
